import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'category-list',
};

const CategoryApi = createApi({
  reducerPath: 'category-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getCategorys: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.category.list, body),
    }),
    createCategory: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.category.create,
        method: 'post',
        body: body,
      }),
    }),
    editCategory: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.category.edit,
        method: 'post',
        body: body,
      }),
    }),
    deleteCategory: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.category.delete,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetCategorysQuery, useCreateCategoryMutation, useEditCategoryMutation, useDeleteCategoryMutation } =
  CategoryApi;
export { CategoryApi };
